import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from '../index.css';
import localStyles from './index.css';
import FontAwesome from 'react-fontawesome';
import {Noria, DryingCleaningUnit, Silo, Hopper} from '../SubComponents/index';
import {dcUnitsStore, scenario, shipment, storageStore} from '../../../stores/index';
import Lines from "./Lines";
import ElementBlock from "./elementBlock";


@observer
export default class ElevatorField extends Component {

    get getNoria(){
       let num = Math.round(storageStore.silosList.length/2);
       let arr = [];
       let list = storageStore.silosList.filter((item)=>{
           return (item.amountState === 'increasing' || (item.status === 'clogged' && item.filingStatus))}
           );
       if(list.length) {
           if (list.length >= num) {
               for (let i = 0; i < num; i++) {
                   arr.push(<Noria culture={list[i].culture} noriaStatus={list[i].status} key={i}/>)
               }
           } else {
               for (let i=0; i < list.length; i++){
                   arr.push(<Noria culture={list[i].culture} noriaStatus={list[i].status} key={i}/>)
               }
               for (let i=0; i < num - list.length; i++){
                   arr.push(<Noria culture='None' key={i+ list.length}/>)
               }
           }
       }else{
           for(let i= 0; i<num;i++){
               arr.push(<Noria culture='None' key={i}/>)
           }
       }
       return (arr);
    }

    render() {
        return (
            <div className={styles.innerContainer + ' ' + styles.elevatorField}>
                <div className={styles.content}>
                    <div className={localStyles.elevatorFieldContainer}>
                        <Lines />

                        <NoriaBlock hopper={true} list={storageStore.hoppersList}/>
                        <ElementBlock title="ХОПЕРИ" icon="iconStoring" list={storageStore.hoppersList} UIComponent={Hopper}/>

                        <NoriaBlock list={dcUnitsStore.dryingList}/>
                        <ElementBlock title="сушка" icon="iconDrying" list={dcUnitsStore.dryingList} UIComponent={DryingCleaningUnit}/>

                        <NoriaBlock list={dcUnitsStore.cleaningList}/>
                        <ElementBlock title="чистка" icon="iconCleaning" list={dcUnitsStore.cleaningList} UIComponent={DryingCleaningUnit}/>

                        <div className={styles.noriaContainer + ' ' +styles.noriaContainerBeforeSilos}>
                            {this.getNoria}
                        </div>

                        <div className={localStyles.silosContainer} >
                            {storageStore.silosList.map((item,i)=>{
                                return (
                                    <div className={localStyles.silo}
                                         onClick={()=>{scenario.openPathPopup(!!item.scenario.length ? item.scenario : item, !!item.scenario.length)}} key={i}>
                                        <Silo item={item} i={i}/>
                                    </div>
                                )
                            })}

                            <div className={localStyles.siloLinesContainer}>
                                <div className={localStyles.fakeContainerForStackingIndex}>
                                    {storageStore.silosList.map((item,i)=>{
                                        return <SiloLine culture={(item.culture !== 'None' && item.filingStatus) ?  item.culture : 'idle'} lineStatus={item.filingStatus ? item.status ? 'clogged' : 'active' : 'idle'} i={i} key={i} />
                                    })}
                                </div>
                            </div>
                            
                            <div className={localStyles.siloContainerDSIcons}>
                                <div><FontAwesome name="trash"/></div>
                                <div><FontAwesome name="tint"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const SiloLine = (props) => {
    return(
        <div style={{width:1.75+props.i*2.75+'rem'}}
            className={localStyles.siloLineInput
        + (props.culture ? ' ' + localStyles[props.culture] : ' ' + localStyles.idle)
        + (props.lineStatus ? ' ' + localStyles[props.lineStatus] : '' )}
        />
    )
};

@observer
class NoriaBlock extends Component{
    render() {
        return (
            <div className={styles.noriaContainer}>
                {this.props.list.map((item, i) => {
                    return (<Noria culture={this.props.hopper ? (item.fillingStatus ? item.culture : "None") : item.culture} noriaStatus={item.status} key={i}/>)
                })}
            </div>
        )
    }
};






// WEBPACK FOOTER //
// ./src/shared/components/Game/ElevatorField/index.js